/**
 * The setup walk (docs/plans/setup-walk.md): the draft used as the owner will
 * use it, every check each time (W3), the blocks first.
 *
 * Pure: the phone bundles it.
 */
import { WALK_CHECK_IDS } from './cards';
import { WALK_CHECKS, type WalkFinding } from './checks';
import type { StudioDraft } from '../setup-draft';

export * from './cards';
export { WALK_CHECKS, type WalkFinding } from './checks';
export { chargeSettleOps, creditBillOps, duesPartyOps, listBillOps, settlePathOps } from './repair';
export { moneyRuleFields, sameJobField } from './edit';
export { journeyProblems, type PlaybookWalk, type PlaybookWalkStep } from './journeys';
export { reachOfField, type ListRead, type Reach as WalkReach } from './reach';

/** Every finding of every check, those that block first, each once. */
export const walkSetup = (draft: Pick<StudioDraft, 'records'>): WalkFinding[] => {
  const all = WALK_CHECK_IDS.flatMap((check) => WALK_CHECKS[check](draft));
  const once = [...new Map(all.map((one) => [one.id, one])).values()];
  return [...once.filter((one) => one.level === 'blocks'), ...once.filter((one) => one.level === 'hint')];
};
